import Vue from "vue"


export const entitycontainerstore = {
  namespaced: true,

  state: {
    EntityMap: {},
  },

  mutations: {
    SET_ENTITY(state, { entityName, entity }) {
      var obj = {
        ...entity,
        loading: false,
        silentloading: false,
        timeStamp: new Date(),
      };

      Vue.set(state.EntityMap, entityName, obj);
    },
    SET_ENTITY_LOADING(state, { entityName, value, silent }) {
      var obj = Object.assign({}, state.EntityMap[entityName]);
      if (!silent) {
        obj.loading = value;
      }
      obj.silentloading = value;
      Vue.set(state.EntityMap, entityName, obj);
    },
  },

  actions: {
    setEntity({ commit }, { entityName, entity }) {
      commit("SET_ENTITY", { entityName, entity });
    },
    setEntityLoading({ commit }, { entityName, value, silent }) {
      commit("SET_ENTITY_LOADING", { entityName, value, silent });
    },
  },

  getters: {
    getEntity: (state) => (entityName) => {
      var entity = state.EntityMap[entityName];

      return entity;
    },
    getEntityLoading: (state) => (entityName) => {
      var loading = state.EntityMap[entityName]?.loading ?? false;

      return loading;
    },
    getEntitySilentLoading: (state) => (entityName) => {
      var loading = state.EntityMap[entityName]?.silentloading ?? false;

      return loading;
    },
  },
};
